import './assets/main.css'

import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import pinia from '@/stores/index'
import ElementPlus from 'element-plus'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import 'element-plus/dist/index.css'
import BaseDialog from './components/WeiDialog.vue'
import BaseTable from './components/BaseTable.vue'
import ExportFile from './components/ExportFile.vue'
import XCheckBox from './components/XCheckBox.vue'

import { useUserStore } from '@/stores';

const app = createApp(App)

app.component('BaseDialog', BaseDialog)
app.component('XCheckBox', XCheckBox)
app.component('ExportFile', ExportFile)
app.component('BaseTable', BaseTable)


const buttonPermissionDirective = {
    mounted(el: {
        style: { display: string }, setAttribute: (arg0: string, arg1: string) => void
    }, binding: { value: string }) {
        const userStore = useUserStore();
        const userPermissions = userStore.userPermissions;
        const requiredPermission = binding.value;
        if (!userPermissions.includes(requiredPermission)) {
            el.style.display = 'none';
        }
    },
};

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component) // 注册所有图标组件
}

app.use(pinia)
app.use(ElementPlus, { locale: zhCn })
app.use(router)
app.directive('permission', buttonPermissionDirective)
app.mount('#app')
